import { COOKIES_AGREEMENT_KEY, ALL_COOKIES, ONLY_TECH_COOKIES } from '../configs/constants';

export function initDefaultCookieAgreement() {
  const cookiesAgreementMode = localStorage.getItem(COOKIES_AGREEMENT_KEY);
  if (cookiesAgreementMode !== ONLY_TECH_COOKIES && cookiesAgreementMode !== ALL_COOKIES) {
    localStorage.setItem(COOKIES_AGREEMENT_KEY, ALL_COOKIES);
  }
}
